module.exports = __webpack_public_path__ + "static/media/53.7b017026.png";